<form #form="ngForm">
  <div class="form-group">
    <label for="cameraType" class="camera-info-label">Camera Type *</label>
    <input
      type="text"
      class="form-control camera-type"
      id="cameraType"
      name="cameraType"
      placeholder="e.g. Close-Up Camera"
      required
      [disabled]="disabled"
      [(ngModel)]="type"
      (blur)="update()">
  </div>
  <div class="form-group">
    <div class="row">
      <div class="col-4">
        <label for="posName" class="camera-info-label">Name *</label>
      </div>
      <div class="col-4">
        <label for="pitch" class="camera-info-label">Pitch *</label>
      </div>
      <div class="col-4">
        <label for="yaw" class="camera-info-label">Yaw *</label>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <input
          type="text"
          class="form-control"
          id="posName"
          name="posName"
          placeholder="e.g. H1"
          maxlength="2"
          required
          [disabled]="disabled"
          [(ngModel)]="posName"
          (blur)="update()">
      </div>
      <div class="col-4">
        <ngx-numeric-textbox
          id="pitch"
          name="pitch"
          placeholder="e.g. 50.8"
          [decimals]="1"
          [format]="'0.0'"
          [min]="-180"
          [max]="180"
          [disabled]="disabled"
          [required]="true"
          [(ngModel)]="pitch"
          (blur)="update()">
        </ngx-numeric-textbox>
      </div>
      <div class="col-4">
        <ngx-numeric-textbox
          id="yaw"
          name="yaw"
          placeholder="e.g. 50.8"
          [decimals]="1"
          [format]="'0.0'"
          [min]="-180"
          [max]="180"
          [disabled]="disabled"
          [required]="true"
          [(ngModel)]="yaw"
          (blur)="update()">
        </ngx-numeric-textbox>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label for="cameraDescription" class="camera-info-label">Description</label>
    <textarea
      class="form-control rounded-0 border-0"
      id="cameraDescription"
      name="cameraDescription"
      rows="3"
      [disabled]="disabled"
      [(ngModel)]="description"
      (blur)="update()">
    </textarea>
  </div>
</form>
